export const demoFinetunesPath = "/p/lens";

export function getDemoFinetuneHref(slug: string): string {
  return `${demoFinetunesPath}/${slug}`;
}
